export default __webpack_public_path__ + "static/media/broken-screen-2.15fd61e9.png";